/**
 * Public site URL for auth redirects (email confirmation, magic links).
 * Set REACT_APP_PUBLIC_SITE_URL in production so confirmation links always use your canonical domain
 * (e.g. https://shop-district88.pages.dev) even if the user started signup from a preview URL.
 */
export function getSiteOrigin(): string {
  const fromEnv = process.env.REACT_APP_PUBLIC_SITE_URL?.trim();
  if (fromEnv) {
    return fromEnv.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
}

/** Where Supabase redirects after the user clicks “Confirm email” in their inbox. */
export function getAuthCallbackUrl(): string {
  const origin =
    getSiteOrigin() ||
    (typeof window !== 'undefined' ? window.location.origin : '') ||
    'https://joindistrict88.com';
  return `${origin.replace(/\/$/, '')}/auth/callback`;
}
